import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import * as Sentry from '@sentry/react';
import store from './store/store';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './intecerptors/axios.interceptor';
import 'react-toastify/dist/ReactToastify.css';
import { ConfigProvider } from 'antd';
import { MantineProvider } from '@mantine/core';
import './scss/global.scss';
import '@mantine/core/styles.css';
import 'antd/dist/antd.min.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import { theme } from './integrations/mantine';
import { AdvanceSearchProvider } from './hooks/tables/AdvanceSearchContext';

Sentry.init({
  dsn: 'https://f500ddea93663ed35dbd513d031b0e40@o4511112043692032.ingest.us.sentry.io/4511112070168576',
  integrations: [Sentry.browserTracingIntegration()],
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [],
});

if (typeof global === 'undefined') {
  window.global = window;
}

// Silence React warnings from antd v4 (defaultProps deprecation)
const originalError = console.error;
console.error = (...args: any[]) => {
  if (typeof args[0] === 'string' && args[0].includes('Support for defaultProps will be removed')) {
    return;
  }
  originalError(...args);
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ConfigProvider>
        <MantineProvider theme={theme} defaultColorScheme="light">
          <ChakraProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <AdvanceSearchProvider>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
                <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                />
              </AdvanceSearchProvider>
            </BrowserRouter>
          </ChakraProvider>
        </MantineProvider>
      </ConfigProvider>
    </Provider>
  </StrictMode>,
);
